<script lang="ts">
    import type { PageData } from './$types';
    import Steps from "$lib/components/Steps.svelte";
    import {afterUpdate, beforeUpdate} from "svelte";
    import {currentProject} from "$lib/stores/projectWizard";
    import {currentCustomer} from "$lib/stores/customer";
    import {beforeNavigate, goto} from "$app/navigation";
    import WizardVenue from "$lib/partials/WizardVenue.svelte";
    import WizardGeneral from "$lib/partials/WizardGeneral.svelte";
    import WizardAdditional from "$lib/partials/WizardAdditional.svelte";
    import WizardAssociated from "$lib/partials/WizardAssociated.svelte";
    import WizardWorkentries from "$lib/partials/WizardWorkentries.svelte";
    import ProjectOverview from "$lib/components/ProjectOverview.svelte";
    import WizardFinal from "$lib/partials/WizardFinal.svelte";
    import { navigating } from '$app/stores'
    import {storeProject} from "$lib/calls/project"
    import {storeFiles} from "$lib/calls/files";
    import {Button, Modal, Spinner} from "flowbite-svelte";
    import {CheckCircleOutline} from "flowbite-svelte-icons";
    import CustomerSelection from "$lib/partials/CustomerSelection.svelte";


    export let data: PageData;

    const now = new Date()

    let project = {
        startsAt: now,
        endsAt: now,
        store: [
            {identityKey: 'department', value: ''},
            {identityKey: 'guests', value: 1},
        ]
    }
    let files = [];
    let loading = false;
    currentProject.subscribe(val => {
        if(val){
            project = val;
        }
    })

    let openModal = false;


    $: steps = [
        {label:'Allgemeine Informationen', route: '/create/project', state: data.step > 0 ? -1 : 0},
        {label:'Veranstaltungsort', route: '/create/project/venue', state: data.step > 1 ? -1 : (data.step === 1 ? 0 : 1)},
        {label:'Erforderliches Personal', route: '/create/project/work-entries', state: data.step > 2 ? -1 : (data.step === 2 ? 0 : 1)},
        {label:'Ansprechpartner', route: '/create/project/associated', state: data.step > 3 ? -1 : (data.step === 3 ? 0 : 1)},
        {label:'Weitere Informationen', route: '/create/project/additional', state: data.step > 4 ? -1 : (data.step === 4 ? 0 : 1)},
    ]

    beforeUpdate(() => {
        //if (project.endsAt.getTime() - project.startsAt.getTime() < 0) {
          //  project.endsAt = project.startsAt;
        //}
    })
    afterUpdate(()=> {
        if(data.step > 0 && (!project.name || project.name.length<1)){
            goto(`/create/project`)
        }
    })
    const process = () => {
        if(data.step === 2) {
            const validWorkEntryCount = project.workEntries.filter(x => x.amount > 0 && x.qualificationId && x.startsAt && x.endsAt)
            if(validWorkEntryCount.length === 0) {
                alert('Bitte fügen Sie mindestens eine Schicht hinzu.')
                return;
            }
        }

        currentProject.set(project)
        if(data.next) {
            goto(`/create/project/${data.next}`)
        } else {
            openModal = true;
        }

    }

    const saveProject = async () => {
        loading = true;
        try {
            const projectData = await storeProject();
            currentProject.set(projectData);
            project = projectData;

            await storeFiles(files);

            currentProject.set(null);
            currentCustomer.set(undefined);

            await goto(`/create/project/thankyou/${projectData.uuid}`);
        } catch (error) {
            console.error("Error saving project:", error);
            alert('Failed to save project. Please try again.');
        } finally {
            loading = false;
        }
    };

    beforeNavigate((ev) => {
        /*if(ev.to.route.id !== '/create/project/[[step]]') {
            currentCustomer.set(undefined)
            currentProject.set(null)
        }*/
    })

</script>
    <div class="mt-1">
    <Steps {steps}/>
    <div class="grid md:grid-cols-3 gap-5">
        {#if $navigating}
            <div class="text-center my-5">
                <Spinner/>
            </div>
        {/if}
        <form class="bg-white mt-5 md:col-span-2 flex flex-col" on:submit|preventDefault={process}>
            {#if data.step === 0 && !$currentCustomer }
                <CustomerSelection/>
            {:else if data.step === 0 && $currentCustomer}
                <WizardGeneral {project}/>
            {:else if data.step === 1}
                <WizardVenue bind:project />
            {:else if data.step === 2}
                <WizardWorkentries bind:project />
            {:else if data.step === 3}
                <WizardAssociated bind:project />
            {:else if data.step === 4}

                <WizardAdditional bind:project />
                <WizardFinal bind:files bind:project />

            {/if}

            <div class="flex mt-8 justify-between place-items-baseline flex-1">
                {#if loading}
                    <div class="text-center my-5">
                        <Spinner/>
                    </div>
                {:else}
                    <Button color="alternative" type="button" on:click={() => {
                        data.step > 0 ? data.step-- : data.step = 0
                        goto(steps[data.step].route)
                    }}>
                        Zurück
                    </Button>
                    <Button type="submit">
                        {#if data.step < 4}
                            Weiter
                        {:else}
                            Projekt Anfragen
                        {/if}
                    </Button>

                {/if}


            </div>
        </form>
        <div class="mt-5 ">
            <ProjectOverview {project}/>
        </div>
    </div>
</div>
<Modal bind:open={openModal} >
    <flex class="flex flex-col gap-3 h-full">
        <div class="">
            <div class="text-center">
                <CheckCircleOutline class="mx-auto mb-4 text-green-500 w-24 h-24 dark:text-gray-200" />
                <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Möchten Sie ihre unverbindliche Anfrage stellen?</h3>

            </div>
        </div>

        <div class="grid grid-cols-2 gap-5">

            <Button color="alternative" class="mr-2" on:click={() => openModal = false}>Nein, Anfrage überarbeiten</Button>
            <Button  on:click={saveProject}>Ja, abschicken</Button>
        </div>
    </flex>

</Modal>

